/** Vencimentos de todos os clientes: procuração e-CAC, certificado digital, alvará, licenças, contratos. */
import { createFileRoute } from '@tanstack/react-router';
import { Vencimentos } from '../telas/vencimentos/vencimentos';

export const Route = createFileRoute('/_app/vencimentos')({ component: Tela });

function Tela() {
  return (
    <>
      <div className="topbar"><div><h1>Vencimentos</h1><div className="sub">o que cada cliente tem com data de validade — o sistema avisa e abre a tarefa de renovação a tempo</div></div></div>
      <div className="conteudo"><Vencimentos /></div>
    </>
  );
}
